var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.$store.getters.isKiosk
      ? _c(
          "div",
          { staticClass: "myHead" },
          [
            _c(
              "v-app-bar",
              {
                staticStyle: { background: "transparent", height: "67px" },
                attrs: { dark: "" },
              },
              [
                !_vm.isHome
                  ? _c(
                      "v-btn",
                      {
                        staticStyle: { "flex-grow": "0" },
                        attrs: { icon: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.goBack.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "myBlack", attrs: { medium: "" } },
                          [_vm._v("mdi-chevron-left")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isHome
                  ? _c(
                      "v-btn",
                      {
                        staticStyle: { "flex-grow": "0" },
                        attrs: { icon: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.menuClicked.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "myBlack", attrs: { medium: "" } },
                          [_vm._v("mdi-menu")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-inline-block text-left pl-1 flex-shrink-1 flex-grow-0 overflow-hidden titleFont pointer",
                    on: {
                      "&click": function ($event) {
                        return _vm.gotoHome.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "mr-2 sharpImage",
                      staticStyle: { height: "60px", "margin-top": "3px" },
                      attrs: { src: require("../assets/Filati-logo.png") },
                    }),
                  ]
                ),
                _c("div"),
                _c(
                  "div",
                  {
                    staticClass: "text-right headIcons",
                    staticStyle: { "flex-shrink": "0" },
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "rounded100",
                        attrs: { icon: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.gotoHome.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "dotImg",
                          staticStyle: { transform: "scale(1.6)" },
                          attrs: {
                            src: require("../assets/icons/wollknaul.png"),
                          },
                        }),
                      ]
                    ),
                    _vm.$store.getters.inhouse &&
                    _vm.$store.state.enableKellnerruf
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "rounded100",
                            attrs: { icon: "" },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.goKellnerruf.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "dotImg soloInvert",
                              attrs: {
                                src: require("../assets/icons/waiter.png"),
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.$store.state.enableNews
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "hidden-xs-only rounded100",
                            attrs: { icon: "" },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.gotoAktuelles.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "myBlack", attrs: { medium: "" } },
                              [_vm._v("mdi-alert-decagram")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-btn",
                      {
                        staticClass: "hidden-sm-and-down rounded100",
                        attrs: { icon: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.goLastOrders.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "myBlack", attrs: { medium: "" } },
                          [_vm._v("mdi-history")]
                        ),
                      ],
                      1
                    ),
                    _vm.itemsCount > 0
                      ? _c(
                          "v-badge",
                          {
                            staticClass: "cart animated",
                            attrs: {
                              color: "#000000",
                              content: _vm.itemsCount,
                              overlap: "",
                              "offset-x": "20",
                              "offset-y": "20",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "rounded100",
                                attrs: { icon: "" },
                                nativeOn: {
                                  "&click": function ($event) {
                                    return _vm.gotoCart.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "myBlack",
                                    attrs: { medium: "" },
                                  },
                                  [_vm._v("mdi-cart")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "v-btn",
                          {
                            staticClass: "rounded100",
                            attrs: { icon: "" },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.gotoCart.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "myBlack", attrs: { medium: "" } },
                              [_vm._v("mdi-cart")]
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
            !_vm.$store.getters.inhouse && _vm.$store.state.showInstallPwa
              ? _c("install")
              : _vm._e(),
          ],
          1
        )
      : !_vm.$store.getters.showKioskSplashOnHome
      ? _c(
          "div",
          { staticClass: "myHead kiosk" },
          [
            _c(
              "v-app-bar",
              {
                staticStyle: { background: "transparent", height: "67px" },
                attrs: { dark: "" },
              },
              [
                !_vm.isHome
                  ? _c(
                      "v-btn",
                      {
                        staticStyle: { "flex-grow": "0" },
                        attrs: { icon: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.goBack.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "myWhite", attrs: { medium: "" } },
                          [_vm._v("mdi-chevron-left")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-inline-block text-left pl-1 flex-shrink-1 overflow-hidden titleFont pointer",
                    on: {
                      "&click": function ($event) {
                        return _vm.gotoHome.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "mr-2 sharpImage",
                      staticStyle: { height: "50px", "margin-top": "5px" },
                      attrs: {
                        src: require("../assets/placeholder6-opti.png"),
                      },
                    }),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "text-right headIcons",
                    staticStyle: { "flex-shrink": "0" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "mr-15 d-inline-block" },
                      [
                        _c(
                          "TripleClick",
                          { on: { "triple-click": _vm.onTripleClickSetup } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "noselect",
                                class: {
                                  invisible: _vm.$store.getters.hideSetupButton,
                                },
                                staticStyle: {
                                  border: "1px solid red",
                                  color: "red",
                                  padding: "2px 15px",
                                },
                              },
                              [_vm._v(" SETUP ")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "rounded100",
                        attrs: { icon: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.gotoHome.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "myWhite", attrs: { medium: "" } },
                          [_vm._v("mdi-home")]
                        ),
                      ],
                      1
                    ),
                    _vm.$store.state.enableNews
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "hidden-xs-only rounded100",
                            attrs: { icon: "" },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.gotoAktuelles.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "myWhite", attrs: { medium: "" } },
                              [_vm._v("mdi-alert-decagram")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.gotoFoods.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "myWhite", attrs: { medium: "" } },
                          [_vm._v("mdi-silverware-fork-knife")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.gotoDrinks.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "myWhite", attrs: { medium: "" } },
                          [_vm._v("mdi-beer")]
                        ),
                      ],
                      1
                    ),
                    _vm.itemsCount > 0
                      ? _c(
                          "v-badge",
                          {
                            staticClass: "cart animated",
                            attrs: {
                              color: "#000000",
                              content: _vm.itemsCount,
                              overlap: "",
                              "offset-x": "20",
                              "offset-y": "20",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "rounded100",
                                attrs: { icon: "" },
                                nativeOn: {
                                  "&click": function ($event) {
                                    return _vm.gotoCart.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "myWhite",
                                    attrs: { medium: "" },
                                  },
                                  [_vm._v("mdi-cart")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "v-btn",
                          {
                            staticClass: "rounded100",
                            attrs: { icon: "" },
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.gotoCart.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "myWhite", attrs: { medium: "" } },
                              [_vm._v("mdi-cart")]
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }